import React from 'react';
import { Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors, spacing, type, useAppTheme } from '@/theme';
import { ScaledSheet } from '@/theme/responsive';

/**
 * Icon + label on the left, value on the right — the row used by appointment details and booking
 * confirmation, which each had a byte-identical private copy of this component and its four
 * styles.
 */
export function DetailRow({
  icon,
  label,
  value,
}: {
  icon: keyof typeof Ionicons.glyphMap;
  label: string;
  value: string;
}) {
  const { colors } = useAppTheme();
  return (
    <View style={styles.detailRow}>
      <View style={styles.detailLeft}>
        <Ionicons name={icon} size={15} color={colors.textTertiary} />
        <Text style={[type.bodySm, styles.detailLabel, { color: colors.textTertiary }]}>{label}</Text>
      </View>
      <Text style={[type.bodyMedium, styles.detailValue, { color: colors.textPrimary }]} numberOfLines={2}>{value}</Text>
    </View>
  );
}

const styles = ScaledSheet.create({
  detailRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', gap: spacing.md },
  detailLeft: { flexDirection: 'row', alignItems: 'center', gap: 6, minWidth: 90, flexShrink: 1 },
  detailLabel: { color: colors.textTertiary, flexShrink: 1 },
  detailValue: { color: colors.textPrimary, flex: 1, textAlign: 'right' },
});
